var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonAddAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.75V4.5H13.5V6.75H11.25V8.25H13.5V10.5H15V8.25H17.25V6.75H15ZM6.75 9C8.4075 9 9.75 7.6575 9.75 6C9.75 4.3425 8.4075 3 6.75 3C5.0925 3 3.75 4.3425 3.75 6C3.75 7.6575 5.0925 9 6.75 9ZM6.75 4.5C7.575 4.5 8.25 5.175 8.25 6C8.25 6.825 7.575 7.5 6.75 7.5C5.925 7.5 5.25 6.825 5.25 6C5.25 5.175 5.925 4.5 6.75 4.5ZM11.5425 10.92C10.2825 10.275 8.6475 9.75 6.75 9.75C4.8525 9.75 3.2175 10.275 1.9575 10.92C1.2075 11.3025 0.75 12.075 0.75 12.915V15H12.75V12.915C12.75 12.075 12.2925 11.3025 11.5425 10.92ZM11.25 13.5H2.25V12.915C2.25 12.63 2.4 12.375 2.64 12.255C3.5325 11.7975 4.9725 11.25 6.75 11.25C8.5275 11.25 9.9675 11.7975 10.86 12.255C11.1 12.375 11.25 12.63 11.25 12.915V13.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAddAlt);
export default __webpack_public_path__ + "static/media/person-add-alt.16f036bd7be3b3614f7c44015ce820e8.svg";
export { ForwardRef as ReactComponent };